import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'task-type',
  templateUrl: './task-type.component.html',
  styleUrls: ['./task-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ButtonModule,
    RippleModule,
    StyleClassModule,
    AsyncPipe,
    TitleCasePipe,
  ],
})
export class TaskTypeComponent implements OnInit {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  taskTypeIcons = [
    { type: 'call', icon: 'fa fa-phone' },
    { type: 'meeting', icon: 'fa fa-users' },
    // {type: 'email', icon: ' fa fa-envelope font-light' },
    // {type:'sms', icon:'fa fa-comments font-light'},
    { type: 'tour', icon: 'fa fa-map-marker-alt' },
  ];
  constructor() {}

  ngOnInit(): void {}

  getIconName(type: string) {
    const iconsTempBuffer = this.taskTypeIcons.find(
      (icons: any) => icons.type === type.toLowerCase(),
    );
    return iconsTempBuffer?.icon;
  }
}
